export function formatSearch(str) {
  let obj = {}
  let arr = str.split('?')[1].split('&')
  arr = Array.from(new Set(arr))
  let arr2 = []
  for (let i of arr) {
    arr2.push(i.split('='))
  }
  for (let key of arr2) {
    if (!obj[key[0]]) {
      obj[key[0]] = key[1]
    } else if (typeof obj[key[0]] === 'string') {
      obj[key[0]] = [obj[key[1]]]
      obj[key[0]].push(key[1])
    } else {
      obj[key[0]].push(key[1])
    }
  }
  let data = JSON.parse(localStorage.getItem('userInfo'))

  if (data) {
    let he = Object.assign(data, obj)
    localStorage.setItem('userInfo', JSON.stringify(he))
  } else {
    localStorage.setItem('userInfo', JSON.stringify(obj))
  }
}

export function formatLocation(value) {
  const longlat = parseFloat(value)
  if (longlat.toString().indexOf('.') > 0) {
    const longlatsplit = value.toString().split('.')
    if (longlatsplit.length >= 2) {
      return (
        parseFloat(longlatsplit[0] === '' ? 0 : longlatsplit[0]) +
        parseFloat('.' + longlatsplit[1].slice(0, 6))
      )
    }
  }
  return longlat
}
